import { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import ModalWrapper from "../../../components/ModalWrapper";
import GridIndex from "../../../components/GridIndex";
import axios from "../../../services/Api";
import { extractStudentIds } from "./dailyPlannerUtils";

const columns = [
  {
    field: "sl_no",
    headerName: "S.No.",
    flex: 0.4,
    sortable: false,
    valueGetter: (value, row) => row.sl_no,
  },
  {
    field: "student_name",
    headerName: "Student Name",
    flex: 1,
  },
  {
    field: "auid",
    headerName: "AUID",
    flex: 1,
    valueGetter: (value, row) => row.auid || "-",
  },
  {
    field: "usn",
    headerName: "USN",
    flex: 1,
    valueGetter: (value, row) => row.usn || "-",
  },
];

const DailyPlannerStudentListDialog = ({ item, open, setOpen }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchStudents = async () => {
      if (!open || !item?.id) {
        setRows([]);
        return;
      }

      setLoading(true);
      try {
        const idsResponse = await axios.get(
          `/api/getActiveStudentsByDailyPlannerId/${item.id}`
        );
        const studentIds = extractStudentIds(idsResponse.data);

        if (!studentIds.length) {
          setRows([]);
          return;
        }

        const detailsResponse = await axios.get(
          `/api/student/studentDetailsByStudentIds/${studentIds.join(",")}`
        );
        const details = Array.isArray(detailsResponse.data.data)
          ? detailsResponse.data.data
          : [];

        setRows(
          details.map((student, index) => ({
            id: student.student_id ?? student.id ?? index,
            sl_no: index + 1,
            student_id: student.student_id ?? student.id,
            student_name: student.student_name || "Unknown",
            auid: student.auid ?? "",
            usn: student.usn ?? "",
          }))
        );
      } catch (err) {
        console.error(err);
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    fetchStudents();
  }, [open, item?.id]);

  return (
    <ModalWrapper
      open={open}
      setOpen={setOpen}
      maxWidth={900}
      title={item?.task_title ? `Students - ${item.task_title}` : "Students"}
    >
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress size={28} />
        </Box>
      ) : rows.length === 0 ? (
        <Typography sx={{ py: 3, textAlign: "center" }} color="text.secondary">
          No students are assigned to this task.
        </Typography>
      ) : (
        <Box sx={{ mt: 1 }}>
          <GridIndex rows={rows} columns={columns} />
        </Box>
      )}
    </ModalWrapper>
  );
};

export default DailyPlannerStudentListDialog;
